// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/sticky-header/sticky-header.directive.scss
// module id = 227
// module chunks = 0